import axiosInstance from 'api/axiosInstance';

/**
 * Fetches a single prospect by ID.
 * @param {number | null} prospectId - The ID of the prospect to fetch, or null if invalid.
 * @returns {Promise<any>} - A promise that resolves to the prospect object or null if the ID is invalid.
 */
const getSingleProspect = async (prospectId: number | null): Promise<any> => {
	if (prospectId === null || isNaN(prospectId)) {
		console.error('Invalid prospect ID:', prospectId);
		return null; // Return null for invalid IDs
	}

	try {
		const { data } = await axiosInstance.get(
			`/api/cantrackv3/ReadProspect`,
			{
				params: { id: prospectId },
			},
		);

		console.log('DEBUG: Retrieved prospect data:', data);
		return data;
	} catch (error) {
		console.error('Error fetching prospect:', error);
		throw error;
	}
};

export default getSingleProspect;
